(function () {
  /**
   * Parse a display string like "50.000", "4.9", "17", "1,234" into
   * { value: Number, decimals: Number }.
   *
   * Detection rules:
   *  - "50.000"  → dot followed by 3 digits = thousand separator → 50000, 0 decimals
   *  - "4.9"     → dot followed by 1-2 digits = decimal separator → 4.9, 1 decimal
   *  - "1.234.567" → multiple dots = all thousand separators
   *  - "1.234,56"  → dot=thousand, comma=decimal
   *  - "1,234.56"  → comma=thousand, dot=decimal
   */
  function parseCountValue(str) {
    if (!str) return { value: 0, decimals: 0 };

    const s = str.trim();
    const numStr = s.replace(/[^\d.,]/g, '');
    if (!numStr) return { value: 0, decimals: 0 };

    const dotIdx   = numStr.lastIndexOf('.');
    const commaIdx = numStr.lastIndexOf(',');

    let value, decimals;

    if (commaIdx > dotIdx) {
      // Comma comes last → comma is decimal separator (European)
      // e.g. "1.000,50" or "4,9"
      const cleaned = numStr.replace(/\./g, '').replace(',', '.');
      value    = parseFloat(cleaned);
      decimals = (cleaned.split('.')[1] || '').length;

    } else if (dotIdx > commaIdx) {
      const afterDot = numStr.slice(dotIdx + 1);

      if (afterDot.length >= 3) {
        // 3+ digits after dot → thousand separator (e.g. "50.000", "1.234.567")
        const cleaned = numStr.replace(/[.,]/g, '');
        value    = parseFloat(cleaned);
        decimals = 0;
      } else {
        // 1-2 digits after dot → decimal separator (e.g. "4.9", "3.14")
        const cleaned = numStr.replace(/,/g, '');
        value    = parseFloat(cleaned);
        decimals = afterDot.length;
      }

    } else {
      // No separators
      value    = parseFloat(numStr) || 0;
      decimals = 0;
    }

    return { value: isNaN(value) ? 0 : value, decimals };
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateValue(el, target, decimals, finalText) {
    const duration = 1800;
    const start    = performance.now();

    function step(now) {
      const elapsed  = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased    = easeOutCubic(progress);
      const current  = target * eased;

      if (progress < 1) {
        el.textContent = current.toFixed(decimals) + (el.dataset.plus === 'true' ? '+' : '');
        requestAnimationFrame(step);
      } else {
        el.textContent = finalText;
      }
    }

    requestAnimationFrame(step);
  }

  if (!customElements.get('b4u-counters')) {
    class B4UCounters extends HTMLElement {
      connectedCallback() {
        this._animated = false;

        if (typeof Shopify !== 'undefined' && Shopify.designMode) {
          // Run immediately in the editor so merchants see the animation
          setTimeout(() => this._startAnimation(), 80);
          // Re-run when a block is updated in the editor
          document.addEventListener('shopify:section:load', this._onSectionLoad = (e) => {
            if (e.target.contains(this)) {
              this._animated = false;
              setTimeout(() => this._startAnimation(), 80);
            }
          });
        } else {
          this._setupObserver();
        }
      }

      _setupObserver() {
        this._observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this._animated) {
                this._animated = true;
                this._startAnimation();
                this._observer.disconnect();
              }
            });
          },
          { threshold: 0.25 }
        );
        this._observer.observe(this);
      }

      _startAnimation() {
        this.querySelectorAll('.b4u-cnt__value').forEach((el) => {
          const raw      = el.dataset.value || '';
          const showPlus = el.dataset.plus === 'true';
          const { value, decimals } = parseCountValue(raw);
          const finalText = raw + (showPlus ? '+' : '');

          // Reset to zero so the count-up starts from the bottom
          el.textContent = (0).toFixed(decimals) + (showPlus ? '+' : '');

          animateValue(el, value, decimals, finalText);
        });
      }

      disconnectedCallback() {
        if (this._observer) this._observer.disconnect();
        if (this._onSectionLoad) document.removeEventListener('shopify:section:load', this._onSectionLoad);
      }
    }

    customElements.define('b4u-counters', B4UCounters);
  }
})();
